import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory } from "react-router-dom";
import DispatchContext from "../../contexts/DispatchContext";
import DataFetcher from "../../utils/DataFetcher";
import StateContext from "../../contexts/StateContext";
import LoadingIndicator from "../elements/LoadingIndicator";
import { renderMarkup, dispError } from "../../utils/Tools";

function Download(props) {
  const appDispatch = useContext(DispatchContext);
  const appState = useContext(StateContext);
  const history = useHistory();
  const targetURL = "/page";

  const [page, setPage] = useState(null)

  const loadData = useCallback(() => {
    DataFetcher.fetch(targetURL, {"slug": `/downloads-${appState.user.navType}`})
      .then(response => {
        if (!response.success) {
          appDispatch(dispError(response.msg));
          return history.push("/");
        }
        return setPage(response.page);
      })
      .catch(error => {
        console.error(error);
        return history.push("/");
      });
  }, [appState, appDispatch, history]);

  useEffect(() => {
    loadData()
  }, [loadData])

  useEffect(() => {
    window.document.title = props.title;
  }, [props.title]);

  return (
    <main className="download content">
      { !page && (<LoadingIndicator />) }
      { page && (
        <>
          <h1 className="title">{page.title}</h1>
          { renderMarkup(page.rendered) }
        </>
      ) }
    </main>
  );
}
export default Download;
